export default "Électro-intensité, procédés exonérés, réclamation du trop-versé : vérifiez l'éligibilité de vos sites aux taux réduits d'accise sur l'électricité (ex-CSPE/TICFE). Étude gratuite et confidentielle.";
